/** Phân quyền — mẫu in */
export const MAU_IN_PERMISSION_CODES = {
  WEB_BH_MAU_IN_LIST: 'WEB_BH_MAU_IN_LIST',
  WEB_BH_MAU_IN_EDIT: 'WEB_BH_MAU_IN_EDIT',
} as const

export type MauInPermissionCode =
  (typeof MAU_IN_PERMISSION_CODES)[keyof typeof MAU_IN_PERMISSION_CODES]

export const mauInPermissionCodeValues = Object.values(MAU_IN_PERMISSION_CODES)

export const MAU_IN_READ_PERMISSIONS = [
  MAU_IN_PERMISSION_CODES.WEB_BH_MAU_IN_LIST,
] as const

export const MAU_IN_MUTATE_PERMISSIONS = [
  MAU_IN_PERMISSION_CODES.WEB_BH_MAU_IN_EDIT,
] as const
